/**
 * Helper component to display PDFs.
 * Utilizes react-pdf github: https://github.com/diegomura/react-pdf
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// import third party libraries
import { Document, Page } from 'react-pdf/dist/entry.noworker';
import classNames from 'classnames';
import Scrollchor from 'react-scrollchor';

// import actions
import * as userEventActions from '../../../modules/userEvent/userEventActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

class PDFViewer extends Base {
  constructor(props) {
    super(props);
    this.state = {
      numPages: null
      , pageNumber: 1
    }
    this._bind(
      '_done'
      , '_nextPage'
      , '_onDocumentLoad'
      , '_previousPage'
    )
  }

  _onDocumentLoad = ({ numPages }) => {
      this.setState({
      numPages: numPages
    });
    if(this.props.tracking) {
      this.props.dispatch(userEventActions.sendCreateUserEvent({
        ...this.props.tracking // should contain any relevant keys to save
        , eventType: "pdf"
        , eventAction: "play"
      }));
    }
  }

  _nextPage() {
    // Make sure there is another page before setting pageNumber.
    if(this.state.pageNumber + 1 <= this.state.numPages) {
      this.setState({
        pageNumber: this.state.pageNumber + 1
      });
    }
  }

  _previousPage() {
    // Don't allow pageNumber to be less than 1.
    if(this.state.pageNumber > 1) {
      this.setState({
        pageNumber: this.state.pageNumber - 1
      });
    }
  }

  _done() {
    this.setState({
      pageNumber: 1
    })
    if(this.props.onDone) {
      this.props.onDone()
    }

    if(this.props.tracking) {
      this.props.dispatch(userEventActions.sendCreateUserEvent({
        ...this.props.tracking // should contain any relevant keys to save
        , eventType: "pdf"
        , eventAction: "finish"
      }));
    }
  }

  render() {
    const { numPages, pageNumber } = this.state;
    const {
      autoScroll
      , controls
      , file
      , hidden
      , styles
    } = this.props;
    const pdfWrapperClass = classNames(
      'scene-pdf-wrapper'
      , {
        '-hidden': hidden
      }
    )
    console.log('pdf file', file)
    // const prefix = 'https://pro-ficiency.akamaized.net/visits/';
    // const prefix = 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/visits/'; 
    const prefix = 'https://d2jth2langi9vb.cloudfront.net/visits/'; 
    
    return (
      <div className={pdfWrapperClass + " " + styles} id={autoScroll ? 'pdf-top': null}>
        <div className="-pdf-top-wrapper">
          <Document
            className="-pdf-document"
            file={'/api/scenes/static?url=' + prefix + file} // Using the same api route that we use to fetch videos from akamai.
            onLoadSuccess={this._onDocumentLoad}
          >
            <Page
              className="-pdf-page"
              pageNumber={pageNumber}
              renderTextLayer={false}
              renderAnnotations={false}
              scale={3}
            />
          </Document>
          {pageNumber < numPages ?
            <div className="-hover-overlay -right" onClick={this._nextPage}>
              <i className="fas fa-angle-right"></i>
            </div>
          : 
            <div className="-hover-overlay -right" onClick={this._done}>
              <h2>Next Scene</h2>
            </div>
          }
          {pageNumber != 1 ? 
            <div className="-hover-overlay -left" onClick={this._previousPage}>
              <i className="fas fa-angle-left"></i>
            </div>
          : null
          }
        </div>
        {controls ? 
          <div className='-pdf-nav-controls'>
          { autoScroll ? // Include Scrollchor
            <div className="yt-row center-horiz">
              <Scrollchor to="#pdf-top">
                <div className={`-nav-button -prev ${pageNumber <= 1 ? '-disabled' : ''}`} onClick={this._previousPage}>
                  <i className="fas fa-angle-double-left"/>
                  Previous
                </div>
              </Scrollchor>
              { pageNumber < numPages ? 
              <Scrollchor to="#pdf-top">
                <div className={`-nav-button ${pageNumber >= numPages ? '-disabled' : ''}`} onClick={this._nextPage}>
                  Next
                  <i className="fas fa-angle-double-right"/>
                </div>
              </Scrollchor>
              :
              <Scrollchor to="#pdf-top">
                <div className={`-nav-button`} onClick={this._done}>
                  Next
                  <i className="fas fa-angle-double-right"/>
                </div>
              </Scrollchor>
              }
            </div>
            : // Don't include Scrollchor
            <div>
              <span className={`-nav-button ${pageNumber <= 1 ? '-disabled' : ''}`} onClick={this._previousPage}>
                <i className="fas fa-angle-double-left"/>
                Previous
              </span>
              { pageNumber < numPages ? 
              <span className={`-nav-button ${pageNumber >= numPages ? '-disabled' : ''}`} onClick={this._nextPage}>
                Next
                <i className="fas fa-angle-double-right"/>
              </span>
              :
              <span className={`-nav-button`} onClick={this._done}>
                Next
                <i className="fas fa-angle-double-right"/>
              </span>
              }
            </div>
          }
            <div className="-page-num">
              { pageNumber } of { numPages }
            </div>
          </div>
          :
          null
        }
      </div>
    )
  }
}

PDFViewer.propTypes = {
  autoScroll: PropTypes.bool
  , controls: PropTypes.bool
  , dispatch: PropTypes.func
  , file: PropTypes.string.isRequired
  , styles: PropTypes.string
  , hidden: PropTypes.bool
}

PDFViewer.defaultProps = {
  autoScroll: false
  , controls: true
  , file: ''
  , styles: ''
  , hidden: false
}

export default connect()(PDFViewer);



// WEBPACK FOOTER //
// global/components/helpers/PDFViewer.js.jsx